import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

const STATUS_COLOR = {
  available: "bg-emerald-100 text-emerald-800 border-emerald-300",
  hold: "bg-amber-100 text-amber-800 border-amber-300",
  blocked: "bg-orange-100 text-orange-800 border-orange-300",
  booked: "bg-blue-100 text-blue-800 border-blue-300",
  sold: "bg-slate-200 text-slate-800 border-slate-300",
  cancelled: "bg-rose-100 text-rose-800 border-rose-300",
};

export default function Inventory() {
  const [items, setItems] = useState([]);
  const [projects, setProjects] = useState([]);
  const [proj, setProj] = useState("");
  useEffect(() => { api.get("/projects").then(r => setProjects(r.data)); }, []);
  useEffect(() => {
    api.get("/inventory", { params: proj ? { project_id: proj } : {} }).then(r => setItems(r.data));
  }, [proj]);

  const towers = [...new Set(items.map(i => i.tower))];
  return (
    <div className="space-y-6 animate-in">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">Commercial</div>
          <h1 className="font-serif-display text-3xl">Inventory Grid</h1>
        </div>
        <div className="w-64">
          <Select value={proj} onValueChange={v => setProj(v === "__all" ? "" : v)}>
            <SelectTrigger data-testid="inventory-project-filter"><SelectValue placeholder="All projects"/></SelectTrigger>
            <SelectContent>
              <SelectItem value="__all">All projects</SelectItem>
              {projects.map(p => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      </div>
      {towers.length === 0 && <Card className="p-10 text-center text-muted-foreground">No inventory. Select a project or seed data.</Card>}
      {towers.map(t => (
        <Card key={t} className="p-4">
          <div className="text-[11px] uppercase tracking-widest text-muted-foreground mb-3">{t}</div>
          <div className="grid grid-cols-4 md:grid-cols-8 gap-2">
            {items.filter(i => i.tower === t).map(u => (
              <div key={u.id} className={`p-2 border rounded text-xs ${STATUS_COLOR[u.status] || "bg-secondary"}`} data-testid={`inv-${u.unit_number}`}>
                <div className="font-mono font-semibold">{u.unit_number}</div>
                <div className="text-[10px]">{u.configuration} · {u.carpet_area} sqft</div>
                <div className="uppercase text-[9px] tracking-wider mt-1">{u.status}</div>
              </div>
            ))}
          </div>
        </Card>
      ))}
    </div>
  );
}
